module.exports = __webpack_public_path__ + "img/delete.3b1ba3b9.svg";